import AllInvoicesTable from '@/components/Templates/Invoices/AllInvoicesTable';

const AllInvoice = () => {
	return <AllInvoicesTable />;
};

export default AllInvoice;